import Create from "./Create";
import List from "./List";
import Update from "./Update";

export const Category = {
  List: List,
  Update: Update,
  Create: Create,
  Permissions: {
    create: "create:Category",
    update: "update:Category",
    list: "list:Category",
    read: "read:Category",
  },
};
